import { AvailableDates, Proposal, ProposalDetailsData } from '@/controllers/Activity';
import { selectRequestStatus } from '@/store/reducers/api-requests/selectors';
import { AppState } from '@/types';

import { ActivitiesReducerState as State } from './types';

export const selectActivityListIsUpdating = (state: AppState): boolean => {
  return selectRequestStatus(state, 'activities|fetchActivities');
};

export const selectActivities = (state: AppState): State['list'] => {
  return state.activities.list;
};

export const selectTotalAmountOfActivities = (state: AppState): State['total'] => {
  return state.activities.total;
};

export const selectActivityDetailsData = (state: AppState): ProposalDetailsData => {
  return state.activities.activityDetailsData as ProposalDetailsData;
};

export const selectActivityDetailsPageIsLoading = (state: AppState): boolean => {
  return (
    selectRequestStatus(state, 'dictionaries|fetchActivityStatuses') ||
    selectRequestStatus(state, 'dictionaries|fetchProposalStatuses') ||
    selectRequestStatus(state, 'activities|fetchActivityData') ||
    selectRequestStatus(state, 'activities|fetchActivityDetailsData')
  );
};

export const selectAlbumLinkIsLoading = (state: AppState): boolean => {
  return selectRequestStatus(state, 'activities|updateAlbumLink');
};

export const selectActivityDetailsPageIsLoadingNew = (state: AppState): boolean => {
  return (
    selectRequestStatus(state, 'dictionaries|fetchActivityStatuses') ||
    selectRequestStatus(state, 'dictionaries|fetchProposalStatuses') ||
    selectRequestStatus(state, 'dictionaries|fetchDeliveryTypes') ||
    selectRequestStatus(state, 'dictionaries|fetchAdditionalContactTypes') ||
    selectRequestStatus(state, 'activities|fetchActivityData') ||
    selectRequestStatus(state, 'activities|fetchActivityDetailsData') ||
    selectRequestStatus(state, 'buckets|fetchAttachmentsList')
  );
};

export const selectAppliedFilters = (state: AppState): State['appliedFilters'] => {
  return state.activities.appliedFilters;
};

export const selectDetailsTargetActivity = (state: AppState): State['detailsTargetActivity'] => {
  return state.activities.detailsTargetActivity;
};

export const selectStarredPresent = (state: AppState): State['starredPresent'] => {
  return state.activities.starredPresent;
};

export const selectTaskStatuses = (state: AppState): State['taskStatuses'] => {
  return state.activities.taskStatuses;
};

export const selectMessageBoardId = (state: AppState): string | null => {
  return state.activities.activityDetailsData?.messageBoardId ?? null;
};

export const selectCurrentProposal = (state: AppState): Proposal | null => {
  return state.activities.selectedProposal;
};

export const selectAvailableInstallDates = (state: AppState): AvailableDates | null => {
  return state.activities.availableInstallDates;
};

export const selectAvailableDeliveryDates = (state: AppState): AvailableDates | null => {
  return state.activities.availableDeliveryDates;
};

export const selectActivityId = (state: AppState): string | null => {
  return state.activities.activityDetailsData?.activityId ?? null;
};
